/*
 * @Description: 获取所属团队
 */
import React from "react"
import PropTypes from "prop-types"
import { withApi } from "@tencent/react-aio"

class AttributionTeam extends React.Component {
  static propTypes = {
    ownerId: PropTypes.number.isRequired,
    ascriptionTeamId: PropTypes.number.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      employeeWorkingTeams: [],
    }
  }

  componentDidMount() {
    const { ownerId, webApi } = this.props
    if (ownerId) {
      webApi
        .getEmployeeWorkingTeams(ownerId)
        .ajax()
        .then(
          (res) => {
            if (res) {
              this.setState({
                employeeWorkingTeams: res,
              })
            }
          },
          (err) => {
            console.error(err.message)
          }
        )
    }
  }

  render() {
    const { ascriptionTeamId } = this.props
    const { employeeWorkingTeams } = this.state
    const [ascriptionTeamName] = employeeWorkingTeams.filter((d) => d.teamId === ascriptionTeamId)
    return <span>{ascriptionTeamName?.name || ""}</span>
  }
}

export default withApi(AttributionTeam)
